<template>
  <div class="mx-4">
    <v-row no-gutters class="mt-6">
      <!-- Título -->
      <v-col cols="12">
        <app-title texto="CADASTRO DE DISPENSAS DO DIAGNÓSTICO" />
      </v-col>

      <!-- Formulário -->
      <v-col cols="12">
        <v-form
          ref="form"
          v-model="valid"
          @submit.prevent="onSubmit"
        >
          <v-row dense>
            <!-- Unidade -->
            <v-col cols="6">
              <select-simple-unidade
                :value="unidade"
                :mapeamento-id="diagnostico ? diagnostico.mapeamento.id : null"
                :disabled="isEdicao"
              />
            </v-col>

            <!-- Usuário a ser Dispensado -->
            <v-col cols="6">
              <v-autocomplete
                v-model="dispensa.usuario"
                :items="usuariosNaoDispensadosDiagnostico"
                :disabled="!unidade.selecionado || isEdicao"
                :rules="rules.usuario"
                item-text="nome"
                class="mx-2"
                label="Servidor"
                prepend-icon="person"
                placeholder="Digite para pesquisar..."
                return-object
              />
            </v-col>
          </v-row>

          <v-row dense>
            <!-- Motivo da Dispensa -->
            <v-col cols="6">
              <v-autocomplete
                v-model="dispensa.motivo"
                :items="motivos"
                :disabled="!dispensa.usuario"
                :rules="rules.motivo"
                item-text="descricao"
                class="mx-2"
                label="Motivo"
                prepend-icon="library_books"
                placeholder="Digite para pesquisar..."
                no-results-text="Nenhum resultado encontrado."
                required
                return-object
                @change="pesquisa.motivo = ''"
              />
            </v-col>

            <!-- Adicionar um Novo Motivo -->
            <v-col>
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn
                    class="mt-4"
                    color="primary"
                    dark
                    text
                    @click="toogleMotivoDispensa"
                    v-on="on"
                  >
                    Adicionar
                    <v-icon class="ml-2">
                      add_circle
                    </v-icon>
                  </v-btn>
                </template>
                <span>Clique para adicionar um motivo de dispensa</span>
              </v-tooltip>
            </v-col>
            <v-spacer />
          </v-row>

          <!-- Botões -->
          <v-col cols="12">
            <v-spacer />
            <v-row
              class="justify-end"
              no-gutters
            >
              <v-row class="justify-end">
                <!-- Botão para Cadastrar e Editar -->
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      :disabled="!unidade.selecionado || !valid"
                      color="primary"
                      class="mr-2"
                      type="submit"
                      v-on="on"
                    >
                      {{ isEdicao ? "Editar" : "Cadastrar" }}
                    </v-btn>
                  </template>
                  <span>Clique no botão para {{ isEdicao ? "editar" : "salvar" }} a dispensa</span>
                </v-tooltip>

                <!-- Botão para Cancelar -->
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      :disabled="!formUpdated"
                      color="primary"
                      outlined
                      class="mr-3"
                      @click="reset"
                      v-on="on"
                    >
                      Cancelar
                    </v-btn>
                  </template>
                  <span>Clique no botão para cancelar
                    {{ isEdicao ? "a edição" : "o cadastro" }} da dispensa</span>
                </v-tooltip>
              </v-row>
            </v-row>
          </v-col>
        </v-form>
      </v-col>
    </v-row>

    <!-- Cadastro e Edição de Motivos de Dispensa do Diagnóstico -->
    <gerenciamento-motivo-dispensa
      :toogle="toogleMotivoDispensa"
      :visibilidade="dialogMotivoDispensa"
      :motivos="motivos"
      :dispensas="dispensas"
      :is-edicao="isEdicaoMotivo"
      :motivo-update="motivoUpdate"
      @hide="toogleMotivoDispensa"
      @return="(value) => addMotivo(value)"
      @update="(value) => updateMotivo(value)"
      @delete="(value) => deleteMotivo(value)"
      @reset="() => resetMotivo()"
    />
  </div>
</template>

<script>
import { RepositoryFactory } from '@/repositories/RepositoryFactory';
import AppTitle from '@/components/core/AppTitle';
import SelectSimpleUnidade from '@/components/SelectSimpleUnidade';
import GerenciamentoMotivoDispensa from '@/components/gerenciamento/diagnostico/GerenciamentoMotivoDispensa';

const usuarioRepository = RepositoryFactory.get('usuario');
const dispensaDiagnosticoRepository = RepositoryFactory.get('dispensaDiagnostico');

export default {
  name: 'DispensaForm',

  components: {
    AppTitle,
    SelectSimpleUnidade,
    GerenciamentoMotivoDispensa,
  },

  props: {
    diagnostico: {
      type: Object,
      required: true,
    },
    dispensas: {
      type: Array,
      required: true,
      default: () => ([]),
    },
    motivos: {
      type: Array,
      required: true,
      default: () => ([]),
    },
    isEdicao: {
      type: Boolean,
      default: false,
      required: false,
    },
    dispensaUpdate: {
      type: Object,
      default: null,
      required: false,
    },
  },

  data() {
    return {
      dispensa: {
        disgnostico: null,
        usuario: null,
        motivo: null,
      },
      defaultDispensa: {
        diagnostico: null,
        usuario: null,
        motivo: null,
      },
      unidade: { selecionado: null },
      usuarios: [],
      rules: {
        usuario: [(v) => !!v || 'Selecione o servidor'],
        motivo: [(v) => !!v || 'Selecione o motivo'],
      },
      valid: false,
      pesquisa: {
        diagnostico: '',
        usuario: '',
        motivo: '',
      },
      motivoUpdate: null,
      dialogMotivoDispensa: false,
      isEdicaoMotivo: false,
    };
  },

  computed: {
    formUpdated() {
      return JSON.stringify(this.dispensa) !== JSON.stringify(this.defaultDispensa);
    },
    usuariosNaoDispensadosDiagnostico() {
      if (this.isEdicao) {
        return this.usuarios;
      }
      return this.usuarios.filter((u) => !this.dispensas.some((d) => d.diagnostico.id === this.diagnostico.id
        && d.usuario.id === u.id));
    },
  },

  watch: {
    diagnostico() {
      this.unidade.selecionado = null;
      this.reset();
    },
    'unidade.selecionado': function (value, oldValue) {
      // Carrega os usuários da unidade selecionada
      // Só carrega os usuários se for a primeira seleção ou se for a seleção de uma unidade diferente
      if ((value && !oldValue) || (value && oldValue && value.id !== oldValue.id)) {
        this.loadUsuariosUnidade(value.id);
      }
    },
    dispensaUpdate(value) {
      if (value && this.isEdicao) {
        this.unidade.selecionado = { ...value.usuario.unidade };
        this.dispensa = { ...value };
      }
    },
    isEdicao(value) {
      if (!value) {
        this.unidade.selecionado = null;
        this.reset();
      }
    },
  },

  created() {
    this.dispensa = { ...this.defaultDispensa };
  },

  methods: {
    loadUsuariosUnidade(unidadeId) {
      usuarioRepository.getByUnidade(unidadeId).then((response) => {
        if (!this.isEdicao) {
          this.reset();
        }
        this.usuarios = response.data;
      });
    },
    onSubmit() {
      if (this.diagnostico) {
        const save = this.isEdicao ? 'update' : 'create';
        const message = this.isEdicao ? 'Dispensa editada com sucesso!' : 'Dispensa cadastrada com sucesso!';
        this.dispensa.diagnostico = { ...this.diagnostico };
        this.dispensa.key = {
          diagnosticoId: this.diagnostico.id,
          usuarioId: this.dispensa.usuario.id,
        };

        dispensaDiagnosticoRepository[save](this.dispensa).then((response) => {
          const dispensa = response.data;
          this.$emit('return', dispensa);
          this.reset();
          this.$store.dispatch('app/success', { response, message });
        });
      }
    },
    addMotivo(motivo) {
      this.$emit('motivo', motivo);
    },
    updateMotivo(motivo) {
      this.isEdicaoMotivo = true;
      this.motivoUpdate = { ...motivo };
    },
    deleteMotivo(motivo) {
      this.$emit('deleteMotivo', motivo);
    },
    toogleMotivoDispensa() {
      this.dialogMotivoDispensa = !this.dialogMotivoDispensa;

      if (!this.dialogMotivoDispensa) {
        this.isEdicaoMotivo = false;
        this.motivoUpdate = null;
      }
    },
    reset() {
      if (this.isEdicao) {
        this.unidade.selecionado = null;
        this.$emit('reset');
      }
      this.$refs.form.resetValidation();
      this.dispensa = { ...this.defaultDispensa };
    },
    resetMotivo() {
      this.isEdicaoMotivo = false;
    },
  },
};
</script>
